// Who may act on a claim; the API enforces the same rules (App\Support\ClaimRoles).
// Each stage includes the ones before it: vetters vet; verifiers vet and verify; the Executive Secretary,
// Directors and agency admins vet, verify and approve. HMO accounts vet.
export const CLAIM_STAGE = { NONE: 0, VET: 1, VERIFY: 2, APPROVE: 3 };

export function claimStage(user) {
  if (!user) return CLAIM_STAGE.NONE;
  if (user.type === "tpa" || user.type === "tpa_employee") return CLAIM_STAGE.VET;
  if (user.type === "shis") return CLAIM_STAGE.APPROVE;
  if (user.type !== "employee") return CLAIM_STAGE.NONE;
  if (String(user.user_role) === "1") return CLAIM_STAGE.APPROVE;
  const title = String(user.job_title || "").trim().toLowerCase();
  if (title === "executive secretary" || title === "director") return CLAIM_STAGE.APPROVE;
  if (title === "claims verifier") return CLAIM_STAGE.VERIFY;
  if (title === "claims vetter") return CLAIM_STAGE.VET;
  return CLAIM_STAGE.NONE;
}
